import { getRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';
import RoomObsolete from '../../offices/models/room/room-obsolete';

const getAllRoomsForOfficeOnDate = async (
  keycloak: KeycloakContext,
  officeId: string | undefined,
  date: string,
): Promise<RoomObsolete[] | undefined> => {
  if (officeId === undefined) {
    return undefined;
  }

  const apiResponse = await getRequest<RoomObsolete[]>(`office/rooms-on-date?officeId=${officeId}&date=${date}`, keycloak);
  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};

export default getAllRoomsForOfficeOnDate;
